
$(document).ready(function () {
    $('#collection-search').on('submit', function (e) {
        e.preventDefault();
        var _this = $(this),
            formData = new FormData(this),
            listController = $('.productgrid--utils, .pagination--container'),
            productList = $('.productgrid--items'),
            collection = formData.get('collection'),
            q = formData.get('q').split(' ').join('*'),
            query = 'variants.sku:' + q + ' OR '+ q + '* ' + collection;

        if (q.trim().length === 0) {
            window.location.reload(true);
        }

        $.ajax({
            url: _this.attr('action'),
            data: {
                type: 'product',
                view: 'json',
                q: query,
            },
            dataType: "html",
            success: function (data) {
                listController.hide();
                productList.html(data).trigger('theme:rimg:watch');
            }
        });
    });

});
